import axios from "../axiosInstance"; // your configured axios instance

export const completePartnerOnboarding = async () => {
  const res = await axios.patch("/partner/onboarding");
  return res.data;
};
